import { render, staticRenderFns } from "./autocomplete-city.vue?vue&type=template&id=587f401a&lang=pug&"
import script from "./autocomplete-city.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-city.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports